
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 64 64"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#62C4C3","d":"M20 35a3 3 0 11-6 0 3 3 0 016 0zm-2 3h-2a4 4 0 00-4 4v3h10v-3a4 4 0 00-4-4z"}}),_c('path',{attrs:{"fill":"#42A5B2","d":"M30 35a3 3 0 11-6 0 3 3 0 016 0zm-2 3h-2a4 4 0 00-4 4v3h10v-3a4 4 0 00-4-4z"}}),_c('path',{attrs:{"fill":"#62C4C3","d":"M40 35a3 3 0 11-6 0 3 3 0 016 0zm-2 3h-2a4 4 0 00-4 4v3h10v-3a4 4 0 00-4-4z"}}),_c('path',{attrs:{"fill":"#42A5B2","d":"M50 35a3 3 0 11-6 0 3 3 0 016 0zm-2 3h-2a4 4 0 00-4 4v3h10v-3a4 4 0 00-4-4z"}}),_c('path',{attrs:{"fill":"#62C4C3","d":"M20 22a3 3 0 11-6 0 3 3 0 016 0zm-2 3h-2a4 4 0 00-4 4v3h10v-3a4 4 0 00-4-4z"}}),_c('path',{attrs:{"fill":"#42A5B2","d":"M30 22a3 3 0 11-6 0 3 3 0 016 0zm-2 3h-2a4 4 0 00-4 4v3h10v-3a4 4 0 00-4-4z"}}),_c('path',{attrs:{"fill":"#62C4C3","d":"M40 22a3 3 0 11-6 0 3 3 0 016 0zm-2 3h-2a4 4 0 00-4 4v3h10v-3a4 4 0 00-4-4z"}}),_c('path',{attrs:{"fill":"#42A5B2","d":"M50 22a3 3 0 11-6 0 3 3 0 016 0zm-2 3h-2a4 4 0 00-4 4v3h10v-3a4 4 0 00-4-4z"}}),_c('path',{attrs:{"fill":"#AA494A","d":"M32 1C14.879 1 1 14.879 1 32s13.879 31 31 31 31-13.879 31-31S49.121 1 32 1zM5 32a26.88 26.88 0 016.552-17.62L49.62 52.448A26.887 26.887 0 0132 59C17.088 59 5 46.912 5 32zm47.448 17.62L14.38 11.552A26.883 26.883 0 0132 5c14.912 0 27 12.088 27 27a26.885 26.885 0 01-6.552 17.62z"}})])
          )
        }
      }
    